module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/right-3-ceadb056637a446dfeb13e15cbf81c09.svg";